import * as yup from 'yup';
import i18n from '../../../../../../../localization/i18n';
import {
    CREDIT_APPLICANT_FIRSTNAME_ERROR,
    CREDIT_APPLICANT_LASTNAME_ERROR,
    LABEL_FIELD_ERROR_INVALID_EMAIL,
    LABEL_FIELD_ERROR_INVALID_PHONE,
    LABEL_FIELD_ERROR_REQUIRED,
} from '../../../../../../../localization/resouceKeys';

export const addNewUserValidations = yup.object().shape({
    email: yup
        .string()
        .required(i18n.t(LABEL_FIELD_ERROR_REQUIRED))
        .email(i18n.t(LABEL_FIELD_ERROR_INVALID_EMAIL))
        // eslint-disable-next-line max-len
        .matches(
            // eslint-disable-next-line max-len
            /^([a-zA-Z0-9_\u00C0-\u024F\-.]+)@([a-zA-Z0-9_\u00C0-\u024F\-.]+)\.([a-zA-Z\u00C0-\u024F]{2,63})$/i,
            i18n.t(LABEL_FIELD_ERROR_INVALID_EMAIL),
        ),
    firstName: yup
        .string()
        .required(i18n.t(LABEL_FIELD_ERROR_REQUIRED))
        .matches(
            // eslint-disable-next-line max-len
            /^[A-Za-z '&,-]{1,30}$/i,
            i18n.t(CREDIT_APPLICANT_FIRSTNAME_ERROR),
        ),
    lastName: yup
        .string()
        .required(i18n.t(LABEL_FIELD_ERROR_REQUIRED))
        .matches(
            // eslint-disable-next-line max-len
            /^[A-Za-z '&,-]{1,30}$/i,
            i18n.t(CREDIT_APPLICANT_LASTNAME_ERROR),
        ),
    phone: yup
        .string()
        .required(i18n.t(LABEL_FIELD_ERROR_REQUIRED))
        .matches(
            // eslint-disable-next-line max-len
            /^\+?[(]?[0-9]{3}\)?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/i,
            i18n.t(LABEL_FIELD_ERROR_INVALID_PHONE),
        ),
});
